(function () {
  'use strict';

  var drawerLock = {
    details: null,
    drawer: null,
    scrollY: 0,
    touchY: 0,
    locked: false,
    styles: null,
  };

  function isMobileDrawer() {
    return window.matchMedia('(max-width: 1024px)').matches;
  }

  function setDrawerViewport() {
    if (!drawerLock.locked || !drawerLock.drawer) return;
    var viewportHeight = window.visualViewport ? window.visualViewport.height : window.innerHeight;
    var header = drawerLock.drawer.closest('.header');
    var headerBottom = header ? header.getBoundingClientRect().bottom : drawerLock.drawer.getBoundingClientRect().top;
    document.documentElement.style.setProperty('--berg-drawer-top', Math.max(0, Math.round(headerBottom)) + 'px');
    document.documentElement.style.setProperty('--berg-drawer-viewport-height', Math.round(viewportHeight) + 'px');
  }

  function preventDrawerScrollChain(event) {
    if (!drawerLock.locked || !event.touches || event.touches.length !== 1) return;
    var target = event.target instanceof Element ? event.target : null;
    var scrollContainer = target && target.closest('#menu-drawer .menu-drawer__navigation-container');
    if (!scrollContainer) {
      event.preventDefault();
      return;
    }

    var currentY = event.touches[0].clientY;
    var deltaY = currentY - drawerLock.touchY;
    var atTop = scrollContainer.scrollTop <= 0;
    var atBottom = scrollContainer.scrollTop + scrollContainer.clientHeight >= scrollContainer.scrollHeight - 1;
    if ((atTop && deltaY > 0) || (atBottom && deltaY < 0)) event.preventDefault();
    drawerLock.touchY = currentY;
  }

  function rememberTouch(event) {
    if (event.touches && event.touches.length === 1) drawerLock.touchY = event.touches[0].clientY;
  }

  function lockPageForDrawer(details, drawer) {
    if (drawerLock.locked || !isMobileDrawer()) return;

    var html = document.documentElement;
    var body = document.body;
    drawerLock.details = details;
    drawerLock.drawer = drawer;
    drawerLock.scrollY = window.scrollY || window.pageYOffset || 0;
    drawerLock.styles = {
      htmlOverflow: html.style.overflow,
      htmlScrollBehavior: html.style.scrollBehavior,
      bodyPosition: body.style.position,
      bodyTop: body.style.top,
      bodyRight: body.style.right,
      bodyBottom: body.style.bottom,
      bodyLeft: body.style.left,
      bodyWidth: body.style.width,
      bodyOverflow: body.style.overflow,
    };
    drawerLock.locked = true;

    html.classList.add('berg-mobile-drawer-open');
    body.classList.add('berg-mobile-drawer-open');
    setDrawerViewport();
    html.style.overflow = 'hidden';
    body.style.position = 'fixed';
    body.style.top = '-' + drawerLock.scrollY + 'px';
    body.style.right = '0';
    body.style.bottom = 'auto';
    body.style.left = '0';
    body.style.width = '100%';
    body.style.overflow = 'hidden';

    document.addEventListener('touchstart', rememberTouch, { passive: true });
    document.addEventListener('touchmove', preventDrawerScrollChain, { passive: false });
    window.addEventListener('resize', setDrawerViewport);
    if (window.visualViewport) window.visualViewport.addEventListener('resize', setDrawerViewport);
  }

  function unlockPageForDrawer() {
    if (!drawerLock.locked) return;

    var html = document.documentElement;
    var body = document.body;
    var restoreY = drawerLock.scrollY;
    var styles = drawerLock.styles;

    document.removeEventListener('touchstart', rememberTouch);
    document.removeEventListener('touchmove', preventDrawerScrollChain);
    window.removeEventListener('resize', setDrawerViewport);
    if (window.visualViewport) window.visualViewport.removeEventListener('resize', setDrawerViewport);

    html.classList.remove('berg-mobile-drawer-open');
    body.classList.remove('berg-mobile-drawer-open');
    html.style.overflow = styles.htmlOverflow;
    html.style.scrollBehavior = 'auto';
    body.style.position = styles.bodyPosition;
    body.style.top = styles.bodyTop;
    body.style.right = styles.bodyRight;
    body.style.bottom = styles.bodyBottom;
    body.style.left = styles.bodyLeft;
    body.style.width = styles.bodyWidth;
    body.style.overflow = styles.bodyOverflow;
    html.style.removeProperty('--berg-drawer-top');
    html.style.removeProperty('--berg-drawer-viewport-height');

    drawerLock.details = null;
    drawerLock.drawer = null;
    drawerLock.styles = null;
    drawerLock.locked = false;
    function restoreScrollPosition() {
      window.scrollTo(0, restoreY);
    }
    restoreScrollPosition();
    window.requestAnimationFrame(function () {
      restoreScrollPosition();
      window.requestAnimationFrame(function () {
        restoreScrollPosition();
        html.style.scrollBehavior = styles.htmlScrollBehavior;
      });
    });
  }

  function bindDrawerState() {
    var drawer = document.querySelector('#menu-drawer');
    var details = drawer && drawer.closest('details');
    if (!drawer || !details || details.dataset.bergDrawerLock === 'true') return;
    details.dataset.bergDrawerLock = 'true';
    details.addEventListener('toggle', function () {
      if (details.open) lockPageForDrawer(details, drawer);
      else if (drawerLock.details === details) unlockPageForDrawer();
    });
    if (details.open) lockPageForDrawer(details, drawer);
  }

  function enhanceDrawer(nav) {
    var navigation = document.querySelector('#menu-drawer .menu-drawer__navigation');
    if (!nav || !navigation || navigation.querySelector('.berg-drawer-primary')) return;

    navigation.querySelectorAll(':scope > .menu-drawer__menu').forEach(function (list) {
      list.classList.add('berg-drawer-original');
    });

    var groups = [
      { label: 'Lumber', links: [
        ['Legacy Series', '/collections/legacy-series'],
        ['Raw Series', '/collections/raw-series'],
        ['Off the Rack', '/collections/stock-bats'],
        ['Limited Series', '/collections/limited-series'],
      ] },
      { label: 'Arsenals', url: nav.dataset.arsenalUrl },
      { label: 'Fungos', links: [
        ['Fully Custom', nav.dataset.customFungoUrl],
        ['Off the Rack', nav.dataset.stockFungoUrl],
      ] },
      { label: 'Training', links: [
        ['Fully Custom', nav.dataset.customTrainerUrl],
        ['Split Grip', 'https://splitgrip.com/'],
        ['Off the Rack', nav.dataset.stockTrainerUrl],
      ] },
      { label: 'Teams', url: 'https://team.bergbat.com' },
      { label: 'More', links: [
        ['Our Story', '/pages/our-story'],
        ['Apparel', '/collections/apparel'],
        ['Bodyguard Bat Sleeve', nav.dataset.bodyguardUrl],
        ['Get in Touch', nav.dataset.contactUrl],
        ['Warranty', '/pages/warranty'],
      ].concat(nav.dataset.rosterEnabled === 'true' ? [['Join the Roster', nav.dataset.rosterUrl]] : []) },
    ];

    var list = document.createElement('ul');
    list.className = 'menu-drawer__menu list-menu berg-drawer-primary';
    groups.forEach(function (group) {
      var item = document.createElement('li');
      if (group.url) {
        var link = document.createElement('a');
        link.className = 'menu-drawer__menu-item list-menu__item link link--text focus-inset';
        link.href = group.url;
        link.textContent = group.label;
        item.appendChild(link);
      } else {
        var details = document.createElement('details');
        details.className = 'berg-drawer-group';
        var summary = document.createElement('summary');
        summary.className = 'menu-drawer__menu-item list-menu__item link link--text focus-inset';
        summary.textContent = group.label;
        var caret = document.createElement('span');
        caret.className = 'berg-drawer-caret';
        caret.setAttribute('aria-hidden', 'true');
        summary.appendChild(caret);
        var links = document.createElement('div');
        links.className = 'berg-drawer-links';
        group.links.forEach(function (entry) {
          var child = document.createElement('a');
          child.href = entry[1];
          child.textContent = entry[0];
          links.appendChild(child);
        });
        details.appendChild(summary);
        details.appendChild(links);
        item.appendChild(details);
      }
      list.appendChild(item);
    });
    navigation.insertBefore(list, navigation.firstChild);
  }

  function enhanceDesktop(nav) {
    if (!nav || nav.dataset.bergReady === 'true') return;
    nav.dataset.bergReady = 'true';
    var menus = Array.prototype.slice.call(nav.querySelectorAll('.berg-site-nav__menu'));

    function closeOthers(active) {
      menus.forEach(function (other) {
        if (other !== active) other.removeAttribute('open');
      });
    }

    menus.forEach(function (menu) {
      var closeTimer;
      function openMenu() {
        window.clearTimeout(closeTimer);
        closeOthers(menu);
        menu.setAttribute('open', '');
      }
      function closeMenu() {
        window.clearTimeout(closeTimer);
        closeTimer = window.setTimeout(function () { menu.removeAttribute('open'); }, 130);
      }
      menu.addEventListener('mouseenter', openMenu);
      menu.addEventListener('mouseleave', closeMenu);
      menu.addEventListener('focusin', openMenu);
      menu.addEventListener('focusout', function () {
        window.setTimeout(function () {
          if (!menu.contains(document.activeElement)) closeMenu();
        }, 0);
      });
      var summary = menu.querySelector(':scope > summary');
      if (summary) {
        summary.addEventListener('click', function (event) {
          if (event.detail > 0 && window.matchMedia('(min-width: 1025px) and (hover: hover)').matches) {
            event.preventDefault();
            openMenu();
          }
        });
      }
      menu.addEventListener('toggle', function () {
        if (!menu.open) return;
        closeOthers(menu);
      });
    });

    document.addEventListener('click', function (event) {
      if (nav.contains(event.target)) return;
      menus.forEach(function (menu) { menu.removeAttribute('open'); });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      menus.forEach(function (menu) { menu.removeAttribute('open'); });
    });
  }

  function init() {
    var nav = document.querySelector('.berg-site-nav');
    if (!nav) return;
    enhanceDesktop(nav);
    enhanceDrawer(nav);
    bindDrawerState();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', function () {
    if (drawerLock.details && !document.documentElement.contains(drawerLock.details)) unlockPageForDrawer();
  });
  window.addEventListener('pagehide', unlockPageForDrawer);
})();
